import script from "./CreatePromotion.vue?vue&type=script&lang=ts&setup=true"
export * from "./CreatePromotion.vue?vue&type=script&lang=ts&setup=true"

import "./CreatePromotion.vue?vue&type=style&index=0&id=7746389e&scoped=true&lang=css"

import exportComponent from "/home/forge/tenant.mybcr.dev/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7746389e"]])

export default __exports__